// extracted by mini-css-extract-plugin
export default {"description":"NotificationCard_description__D39lu"};